/* ---------------------------------------------------------------------------
vue側で呼び出す場合
 import { useLoaderStore } from "@/stores/loaderStore";
 const loaderStore = useLoaderStore();
 例）loaderStore.isLoading;
 例）loaderStore.startLoading();
---------------------------------------------------------------------------- */

import AuthUserStub from "@/stubs/AuthUser";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("AuthStore", {
	persist: true,
	state: () => ({
		isAuthenticated: false,
		user: { ...AuthUserStub }
	}),
	actions: {
		/* ---------------------------------------------------------------------------
    ログアウト時に認証情報、ユーザー情報をリセットする
    ---------------------------------------------------------------------------- */
		userReset() {
			this.user = { ...AuthUserStub };
			this.isAuthenticated = false;
		}
	}
});
